class FaqNew extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.toggleButtons = this.querySelectorAll('[data-faq-toggle]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.toggleButtons.forEach((button) => {
      button.addEventListener('click', this.handleToggle.bind(this));
    });
  }

  handleToggle(event) {
    const button = event.currentTarget;
    const item = button.closest('.faq-new__item');
    const content = item.querySelector('[data-faq-content]');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.closeItem(button, item, content);
    } else {
      this.openItem(button, item, content);
    }
  }

  openItem(button, item, content) {
    button.setAttribute('aria-expanded', 'true');
    item.setAttribute('aria-expanded', 'true');
    content.style.maxHeight = content.scrollHeight + 'px';
  }

  closeItem(button, item, content) {
    button.setAttribute('aria-expanded', 'false');
    item.setAttribute('aria-expanded', 'false');
    content.style.maxHeight = '0';
  }
}

customElements.define('faq-new', FaqNew);

document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('.faq-new');
  faqSections.forEach((section) => {
    if (!customElements.get('faq-new')) {
      customElements.define('faq-new', FaqNew);
    }
    new FaqNew.call(section);
  });
});
